import { createAgxConfig } from '@urbanx/agx.auth.client';

const AppConfig = createAgxConfig(import.meta.env, globalThis.location.origin);

export default AppConfig;
